import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    loggedUser: {},
    isLoggedUserQueryDone: false
  },
  getters: {
    loggedUser: state => state.loggedUser,
    isLoggedUserQueryDone: state => state.isLoggedUserQueryDone
  },
  mutations: { // Synchronous
    setLoggedUser(state, user) {
      Vue.set(state, 'loggedUser', user);
    },
  },
  actions: { // can be async
  },
}